/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sentat1Inputs */

const en__field_sentat1 = /** @type {(inputs: _Field_Sentat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent at`)
};

const de__field_sentat1 = /** @type {(inputs: _Field_Sentat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versendet am`)
};

/**
* | output |
* | --- |
* | "Sent at" |
*
* @param {_Field_Sentat1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sentat1 = /** @type {((inputs?: _Field_Sentat1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sentat1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sentat1(inputs)
	return de__field_sentat1(inputs)
});
export { _field_sentat1 as "_field_sentAt" }